
import { QRCodeSVG } from "qrcode.react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
} from "@/components/ui/dialog";

interface QRCodeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  qrValue: string;
}

export const QRCodeDialog = ({ open, onOpenChange, qrValue }: QRCodeDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-gradient-to-br from-card to-secondary/30 border-none">
        <DialogHeader>
        </DialogHeader>
        <div className="text-center p-6">
          <div className="bg-secondary p-4 rounded-xl shadow-lg border border-muted/20 inline-block mb-4">
            <QRCodeSVG
              value={qrValue}
              size={256}
              level="H"
              className="mx-auto"
            />
          </div>
          <p className="text-sm text-muted-foreground">
            Scan this QR code to join the queue
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
